'use client';

import { use, useEffect } from 'react';

import { NormalizedBrand, NormalizedEntity } from '@ravago/shared/page-data/models/contentful-mapped';
import { RibbonContext } from '@ravago/shared/page-elements-radiance/providers/ribbon-context-providers';
import { getCountryCode } from '@ravago/shared/page-elements-radiance/utils/locale/locale.utils';
import { useTranslations } from '@ravago/shared/translations/client';

interface Props {
  locale: string;
  contentType: string | undefined;
  contentEntity: NormalizedEntity | null;
}

const BrandRibbon = ({ contentType, contentEntity, locale }: Props) => {
  const translate = useTranslations();
  const { dispatch } = use(RibbonContext);

  useEffect(() => {
    if (!contentEntity || contentType !== 'brand') return;

    const country = getCountryCode(locale);
    const isoCodes = (contentEntity as NormalizedBrand).countries.map((normalizedCountry) => normalizedCountry.isoCode);

    if (!isoCodes?.includes(country)) {
      dispatch({ type: 'show_ribbon', value: { variant: 'error', message: translate('page-consumer.brand-detail-alert'), closable: true } });
    }
  }, []);

  return null;
};

export default BrandRibbon;
